/* 🤖 this file was generated by script */
export const wsolidiconMarkerPin01 = {
  name: 'marker_pin_01',
  data: `<svg viewBox="0 0 24 24"><path fill="currentColor" fill-rule="evenodd" d="M3 10a9 9 0 0 1 18 0c0 2.53-1.15 4.74-2.7 6.77a53 53 0 0 1-4.65 5l-.94.94a1 1 0 0 1-1.42 0l-.94-.94a53 53 0 0 1-4.64-5C4.15 14.74 3 12.53 3 10m12 0a3 3 0 1 1-6 0 3 3 0 0 1 6 0" clip-rule="evenodd"/></svg>`,
  iconStyle: 'solid',
};
